export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/plane-blue.4a6ddd5d-5a4629.svg";